import { useEffect, useRef } from 'react';
import { useTranslation } from 'src/lib/i18n/useTranslation';
import Isolate from './isolate';
import styles from './LoadingIndicator.module.scss';
import { Offscreen } from './Offscreen';

interface LoadingIndicatorProps {
  isolate?: boolean,
  displayText?: boolean,
}

export const LoadingIndicator = ({ isolate = false, displayText = true }: LoadingIndicatorProps) => {
  const { t } = useTranslation();
  const loaderRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const isolator = loaderRef.current
      ? new Isolate(loaderRef.current)
      : null;

    if (isolator) {
      if (isolate) {
        isolator.activate();
      } else {
        isolator.deactivate();
      }
    }

    return () => {
      isolator?.deactivate();
    };
  }, [isolate]);

  useEffect(() => {
    const ref = loaderRef.current;
    if(ref) {
      ref.focus();
    }
  }, []);

  return (
    <div ref={ loaderRef } tabIndex={ -1 } className={ styles.container } data-isolate={ isolate ? 'true' : 'false' }>
      <div className={ styles.loader }>
        <div className={ styles.loaderGraphic }></div>
        <div className={ styles.loaderText } role='alert'>
          { displayText ?
            <>
              { t('general_loading') }…
            </>
            :
            <Offscreen>
              { t('general_loading') }…
            </Offscreen>
          }
        </div>
      </div>
    </div>
  );
};
